module.exports = __webpack_public_path__ + "img/1.02bc7560.png";